<template>
  <router-link
    v-if="tenderId"
    class="d-flex align-self-center mt-auto mb-3"
    data-qa="go-to-tenderitem"
    :to="{name: 'tenderitem', params: { id: tenderId, org: $route.params.org}}">
    <sButton
      icon="long-arrow"
      icon-class="s-svg-icon-rotate-90"
      icon-size="12px"
      type="text">
      {{ $t('Tenders.BackToTender') }}
    </sButton>
  </router-link>
  <sButton
    v-else
    icon="long-arrow"
    icon-class="s-svg-icon-rotate-90"
    icon-size="12px"
    type="text"
    @click="$emit('click')">
    {{ $t('Tenders.BackToTender') }}
  </sButton>
</template>

<script>
export default {
  name: 'backToTenderBtn',
  props: {
    tenderId: [Number, String]
  }
}
</script>
